module.exports = __webpack_public_path__ + "static/media/hs-issue.6da1a295.jpg";